export const hotAccessories = {
    music: [
        {
            name: "Redmi Earbuds S",
            price: "₹ 1,799",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/BF2A4279-A6D5-B4F0-FE37-633256CDC9FC.jpg",
        },
        {
            name: "Mi Soundbar",
            price: "₹ 4,999",
            image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1547107203.76021206.png",
        },
        {
            name: "Mi Neckband Bluetooth Earphones",
            price: "₹ 1,599",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/A1C40BA8-574D-2FA0-62C0-3D7A2C964790.jpg",
        },
        {
            name: "Mi Super Bass Wireless Headphones",
            price: "₹ 1,799",
            image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1563264530.44121333.jpg?width=420&height=420",
        },
        {
            name: "Mi Dual Driver In-ear Earphones",
            price: "₹ 799",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/E794F82C-8858-02F1-7C53-6FB0B4D0C4C6.jpg",
        },
    ],
    smartDevice: [
        {
            name: "Mi Smart Band 4",
            price: "₹ 2,099",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/0E0F0769-6A69-5820-C8F0-F2B956C65BFA.jpg",
        },
        {
            name: "Mi Smart Water Purifier",
            price: "₹ 12,999",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/BC643CF4-853C-24E4-1EEC-9D4FF614C86D.jpg",
        },
        {
            name: "Mi Watch Revolve",
            price: "₹ 9,999",
            image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1601293021.06313819.png",
        },
        {
            name: "Mi Smart Bedside Lamp 2",
            price: "₹ 2,499",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/6A656178-B31B-39D1-AC43-9C7EC61C3D84.jpg",
        },
        {
            name: "Mi Smart LED Desk Lamp 1S",
            price: "₹ 2,499",
            image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1574669860.58966823.jpg?width=420&height=420",
        },
    ],
    home: [
        {
            name: "Mi Air Purifier 3",
            price: "₹ 10,999",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/70A72569-C7EA-BBD7-591E-DC93EC3CDF34.jpg",
        },
        {
            name: "Mi Air Purifier 2C",
            price: "₹ 6,999",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/7D8FAD13-1E44-9475-3555-949CBF3571AF.jpg",
        },
        {
            name: "Mi Router 4C",
            price: "₹ 999",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/FD13B2EB-1AD5-67EE-FF6B-C3E2A0270556.jpg",
        },
        {
            name: "Mi Box 4K",
            price: "₹ 3,499",
            image: "https://i02.appmifile.com/919_updatepdf_in/15/05/2020/984e626e158fdeb7cc21aff04264773d.png",
        },
        {
            name: "Mi LED Wi-Fi Smart Bulb",
            price: "₹ 1,299",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/441FC065-EEE7-5A64-9CF9-608EF2F82F60.jpg",
        },
    ],
    lifeStyle: [
        {
            name: "Mi Travel Backpack",
            price: "₹ 1,999",
            image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1536381648.16353261.png?width=420&height=420",
        },
        {
            name: "Mi Athleisure Shoes",
            price: "₹ 1,699",
            image: "https://i02.appmifile.com/363_operator_in/13/10/2020/c7bde508f128d7b1fd10a224d18a5333.png",
        },
        {
            name: "Mi Beard Trimmer",
            price: "₹ 1,399",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/CEEE67A3-3578-7048-887D-CFC3D90B5D17.jpg",
        },
        {
            name: "Mi KN-95 Protective Mask (Pack of 5)",
            price: "₹ 399",
            image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1602500062.48215120.png?width=420&height=420",
        },
        {
            name: "Mi Portable Electric Air Compressor",
            price: "₹ 2,499",
            image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1592479075.0368979.png?width=420&height=420",
        },
        {
            name: "Mi T-shirts",
            price: "₹ 399 onwards",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/0D320403-6180-D6D6-9F57-4EDF0FEB58C7.jpg",
        },
    ],
    mobileAccessories: [
        {
            name: "Cases & Covers",
            price: "₹ 49 onwards",
            image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1551164869.57618003.jpg",
        },
        {
            name: "Charger & USB Gadgets",
            price: "₹ 179 onwards",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/5A5AA9AC-41A3-7E86-5922-928B312919B0.jpg",
        },
        {
            name: "Mi Wireless Power Bank 10000mAh",
            price: "₹ 2,499",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/3CBAACCE-D18A-B241-A4F8-54A4CCE194A5.jpg",
        },
        {
            name: "10000mAh Mi Power Bank 3i",
            price: "₹ 999",
            image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1600434881.35114664.jpg?width=420&height=420",
        },
        {
            name: "Redmi SonicBass Wireless Earphones",
            price: "₹ 1,299",
            image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1601900775.75794078.png?width=420&height=420",
        },
    ],
};

export const data = {
    logo: "https://i01.appmifile.com/webfile/globalimg/pandora/mi-logo.svg",
    miPhones: [
        {
            name: "Mi 11 Ultra 5G",
            price: "₹ 69,999",
            image: "https://i02.appmifile.com/867_operator_in/23/04/2021/3849c44ac78d65621750a114811711f9.png?width=140&height=140",
        },
        {
            name: "Mi 11X Pro 5G",
            price: "from ₹ 39,999",
            image: "https://i02.appmifile.com/52_operator_in/04/03/2021/7db1136dfdc2a1e9fc639b56bc19f17f.png?width=140&height=140",
        },
        {
            name: "Mi 11X 5G",
            price: "from ₹ 29,999",
            image: "https://i02.appmifile.com/368_operator_in/23/04/2021/93d54b25b3efc3b6e87a9d73004de1c3.png?width=140&height=140",
        },
        {
            name: "Mi 10T Pro",
            price: "₹ 36,999",
            image: "https://i02.appmifile.com/406_operator_in/15/10/2020/4481bf3c3bb2ce53d9f4ac6ce1d7e312.png?width=140&height=140",
        },
        {
            name: "Mi 10T",
            price: "from ₹ 32,999",
            image: "https://i02.appmifile.com/938_operator_in/15/10/2020/4e6b056c8984ad7031873ae9b5f564a5.png?width=140&height=140",
        },
        {
            name: "Mi 10i",
            price: "from ₹ 20,999",
            image: "https://i02.appmifile.com/606_operator_in/05/01/2021/3de2b587f140a830fc732855a0a76035.png?width=140&height=140",
        },
    ],
    redmiPhones: [
        {
            name: "Redmi Note 10 Pro Max",
            price: "from ₹ 18,999",
            image: "https://i02.appmifile.com/45_operator_in/04/03/2021/890c4652df767017f4857c5e90647d2b.png?width=140&height=140",
        },
        {
            name: "Redmi Note 10 Pro",
            price: "from ₹ 15,999",
            image: "https://i02.appmifile.com/52_operator_in/04/03/2021/7db1136dfdc2a1e9fc639b56bc19f17f.png?width=140&height=140",
        },
        {
            name: "Redmi Note 10S",
            price: "from ₹ 14,999",
            image: "https://i02.appmifile.com/828_operator_in/13/05/2021/c52a15e98e975abedb43eb92bc5d3bcb.jpg?width=140&height=140",
        },
        {
            name: "Redmi Note 10",
            price: "from ₹ 12,499",
            image: "https://i02.appmifile.com/205_operator_in/04/03/2021/0e33cafd058d5340bc4afb329bb84ca3.png?width=140&height=140",
        },
        {
            name: "Redmi 9 Power",
            price: "from ₹ 10,499",
            image: "https://i02.appmifile.com/330_operator_in/17/12/2020/0d20a99f729de496ab65cda4f5389e4d.png?width=140&height=140",
        },
    ],
    tv: [
        {
            name: "Mi QLED TV 189.34cm (75)",
            price: "₹ 1,24,999",
            image: "https://i02.appmifile.com/620_operator_in/23/04/2021/3c98ae4c034583122a67669c840f249e.jpg?width=140&height=140",
        },
        {
            name: "Mi QLED TV 4K 138.8 cm (55)",
            price: "₹ 57,999",
            image: "https://i02.appmifile.com/572_operator_in/16/12/2020/4d07d0c887a4c08fd05ca06e7cd574e3.jpg?width=140&height=140",
        },
        {
            name: "Redmi Smart TV X Series",
            price: "₹ 33,999",
            image: "https://i02.appmifile.com/126_operator_in/24/03/2021/8864007fcaa4d9815f02b827c29f100f.png?width=140&height=140",
        },
        {
            name: "Mi TV 4A 108 cm (43)",
            price: "₹ 25,999",
            image: "https://i02.appmifile.com/733_operator_in/07/09/2020/a032f1b0bb0025dcb1c12caab81a9d4b.png?width=140&height=140",
        },
        {
            name: "Mi TV 4A 100 cm (40)",
            price: "₹ 23,999",
            image: "https://i02.appmifile.com/986_operator_in/01/06/2021/f2b7747ce2bf0365e4414eb323b97ed5.jpg?width=140&height=140",
        },
    ],
    laptop: [
        {
            name: "Mi Notebook 14 Horizon",
            price: "From ₹ 54,999",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/81DAE22D-023B-1742-5400-32A7760B0962.jpg?width=140&height=140",
        },
        {
            name: "Mi Notebook 14(IC)",
            price: "From ₹ 43,999",
            image: "https://i02.appmifile.com/763_operator_in/19/01/2021/4be770942f3352ad2e7e3a94e5d75a43.jpg?width=140&height=140",
        },
        {
            name: "Mi Notebook 14",
            price: "From ₹ 41,999",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/9534EF41-E7D9-025C-A287-B4BAFCA4A0F9.jpg?width=140&height=140",
        },
        {
            name: "Mi NoteBook 14 e-Learning Edition",
            price: "₹ 38,999",
            image: "https://i02.appmifile.com/234_operator_in/05/11/2020/5b641713340b4a542b75cf737ed2cd80.png?width=140&height=140",
        },
        {
            name: "Mi Webcam HD",
            price: "₹ 1,099",
            image: "https://i02.appmifile.com/504_operator_in/05/01/2021/d465ac7bca989e33487b4b4f2447c3ea.png?width=140&height=140",
        },
    ],
    fitnessAndLifeStyle: [
        {
            name: "Mi Watch Revolve",
            price: "₹ 9,999",
            image: "https://i02.appmifile.com/669_operator_in/29/09/2020/492027bef78ed4c69cfd68c2d299d49f.png?width=140&height=140",
        },
        {
            name: "Redmi Watch GPS",
            price: "₹ 3,999",
            image: "https://i02.appmifile.com/594_operator_in/13/05/2021/7a6d0c6dfdc36b8e65a210c6e40e5171.jpg?width=140&height=140",
        },
        {
            name: "Mi Smart Band 5",
            price: "₹ 2,499",
            image: "https://i02.appmifile.com/867_operator_in/29/09/2020/fbf5b3e1948fc961dba533509c5c4b40.png?width=140&height=140",
        },
        {
            name: "Mi Beard Trimmer 1C",
            price: "₹ 999",
            image: "https://i02.appmifile.com/979_operator_in/06/08/2020/855d6e62a97cb56339126c68de3918e9.png?width=140&height=140",
        },
        {
            name: "Mi Athleisure Shoes",
            price: "₹ 1,699",
            image: "https://i02.appmifile.com/205_operator_in/29/09/2020/e989b9be493148ba6461e8b43d4df81d.png?width=140&height=140",
        },
    ],
    home: [
        {
            name: "Mi Robot Vacuum-Mop P",
            price: "₹ 24,999",
            image: "https://i02.appmifile.com/779_operator_in/22/12/2020/b740f2dbab9a4fef11065926e1aacc42.png?width=140&height=140",
        },
        {
            name: "Mi Air Purifier 3",
            price: "₹ 10,999",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/D0577E6F-7952-56FD-86EB-7A3EF9FE33C1.jpg?width=140&height=140",
        },
        {
            name: "Mi Air Purifier 2C",
            price: "₹ 6,999",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/6CFA11D4-6969-C4C8-C8BA-BF3922F82294.jpg?width=140&height=140",
        },
        {
            name: "Mi Smart Water Purifier",
            price: "₹ 12,999",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/0C7A1A6D-BE84-6D55-17DA-37620E1FA483.jpg?width=140&height=140",
        },
        {
            name: "Mi Security Cameras",
            price: "From ₹ 1,799",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/373DBE3D-CC06-07ED-0F10-EB090CF9737E.jpg?width=140&height=140",
        },
    ],
    audio: [
        {
            name: "Mi Smart Speaker",
            price: "₹ 3,999",
            image: "https://i02.appmifile.com/77_operator_in/29/09/2020/842c0032334066f68c60de04c513c6e0.png?width=140&height=140",
        },
        {
            name: "Mi True Wireless Earphones 2",
            price: "₹ 3,999",
            image: "https://i02.appmifile.com/530_updatepdf_in/08/05/2020/dffe54d117f1c15448f6a61933499b20.png?width=140&height=140",
        },
        {
            name: "Redmi Earbuds 2C",
            price: "₹ 1,499",
            image: "https://i02.appmifile.com/722_operator_in/05/01/2021/e82994f46499c08ba408dff5d544745d.png?width=140&height=140",
        },
        {
            name: "Mi Outdoor Bluetooth Speaker (5W)",
            price: "₹ 1,399",
            image: "https://i02.appmifile.com/184_operator_in/27/05/2021/f515132e83f98d32adfd6d4ef5efbd83.png?width=140&height=140",
        },
        {
            name: "Redmi Earphones",
            price: "₹ 399",
            image: "https://i02.appmifile.com/984_operator_in/02/09/2020/35780ad0fbbd75f9ef2d33dc1f75537b.png?width=140&height=140",
        },
    ],
    accessories: [
        {
            name: "Power Banks",
            price: "From ₹ 799",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/B0272C02-9066-1A1B-B63C-DE2C2B169C34.jpg?width=140&height=140",
        },
        {
            name: "Mi Router 4C",
            price: "₹ 999",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/CE0F6208-9AAC-73CB-2F59-130D2E10F999.jpg?width=140&height=140",
        },
        {
            name: "Mi Portable Wireless Mouse",
            price: "₹ 500",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/C79D1AF1-8FCC-F03A-DC26-F9A1EF509DD4.jpg?width=140&height=140",
        },
        {
            name: "Chargers & Cables",
            price: "From ₹ 179",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/84A39CC0-85BC-DCFC-1D33-9BD71D1B131A.jpg?width=140&height=140",
        },
        {
            name: "Cases & Protectors",
            price: "From ₹ 49",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/6D46492D-DB66-A5AF-968C-58443A98FE1E.jpg?width=140&height=140",
        },
    ],
    banner: {
        start: [
            "https://i02.appmifile.com/173_operator_in/09/06/2021/fde866737ea0357305c2d1c852541460.gif",
            "https://i02.appmifile.com/615_operator_in/05/07/2021/a4b26d6b2ad2d6d2edbfb23a8482328e.jpg",
            "https://i02.appmifile.com/762_operator_in/05/07/2021/4c90dda893b43e0153950f36ee37dc03.jpg",
            "https://i02.appmifile.com/645_operator_in/02/06/2021/4e32c24cfdf8c48ad1bc911807cac09e.jpg",
            "https://i02.appmifile.com/232_operator_in/04/06/2021/568c8fd7c3c4368c14c8ef64cda7866b.jpg",
            "https://i02.appmifile.com/3_operator_in/08/06/2021/3e2d6457a1e569145f66318a17ea1e03.jpg",
            "https://i02.appmifile.com/860_operator_in/09/06/2021/15c70c1f59ef4aad235531578c3d1757.jpg",
            "https://i02.appmifile.com/279_operator_in/08/06/2021/072acd0a667c5a0e045ed50a9064c531.jpg",
            "https://i02.appmifile.com/417_operator_in/04/06/2021/36c1c9f10ac411c5ba304d30d60ca234.jpg",
            "https://i02.appmifile.com/172_operator_in/08/06/2021/44c5407a6c9ede6d782bebfd70cecc24.jpg",
            "https://i02.appmifile.com/667_operator_in/09/06/2021/eca16c5a1a97b1f30cedb943e144e2e0.jpg",
            "https://i02.appmifile.com/934_operator_in/07/06/2021/372a6e5d29c26c34b716b0408a533e3f.jpg",
        ],
        end: [
            {
                name: "MI 11X",
                description:
                    "What makes the Mi 11X a huge disruptor is its price tag. It comes with what we call “crazy Xiaomi pricing”",
                source: "TechPP",
                image: "https://i02.appmifile.com/708_operator_in/10/05/2021/2b7fc56c3b3c44f4b11bd9bd2b255749.jpg",
            },
            {
                name: "MI 11X PRO",
                description:
                    "It is easily the most affordable device with a Snapdragon 888 chip and a 108-megapixel camera in the market right now",
                source: "TechPP",
                image: "https://i02.appmifile.com/191_operator_in/10/05/2021/4ccd175347800225dd6b47eb35166e2e.jpg",
            },
            {
                name: "REDMI NOTE 10 PRO MAX",
                description:
                    "The Redmi Note 10 Pro Max’s macro camera captures the tiniest piece of details to stitch together some very good images.",
                source: "India Today",
                image: "https://i02.appmifile.com/52_operator_in/15/03/2021/7f91bdb2f227f8bd679fa96ac2a9fc1f.jpg",
            },
            {
                name: "REDMI NOTE 10",
                description:
                    "The deep contrasts and the richness that AMOLED brings along add a much-needed dimension to the smartphone.",
                source: "TechPP",
                image: "https://i02.appmifile.com/107_operator_in/17/03/2021/fa9bab9cbad1629076b04a17a655559c.jpg",
            },
            {
                name: "MI 10I",
                description:
                    "The Mi 10i clicks authentic, true-to-life photos with an abundance of details in every shot.",
                source: "91Mobiles",
                image: "https://i02.appmifile.com/85_operator_in/11/01/2021/b7600815ae26854c451a39ee88431098.jpg",
            },
            {
                name: "MI QLED TV 4K",
                description: "Redefining Value for Premium TVs",
                image: "https://i02.appmifile.com/108_operator_in/13/01/2021/3bfe5123ede27524d616f0bdaf43945a.jpg",
            },
            {
                name: "MI 10T PRO",
                description:
                    "Mi 10T Pro is a clear winner in the premium segment",
                source: "FoneArena",
                image: "https://i02.appmifile.com/843_operator_in/28/12/2020/226c73c386cf35e47fa0079b3534085f.jpg",
            },
            {
                name: "REDMI 9 POWER",
                description:
                    "In under an hour, the phone was charged around 80 percent plus, which is more than enough battery for two days.",
                source: "Indian Express",
                image: "https://i02.appmifile.com/779_operator_in/28/12/2020/55bbda7ebbb47f674213dead3c0fefdf.jpg",
            },
            {
                name: "MI SMART WATER PURIFIER",
                description:
                    "Mi Smart Water Purifier: The Epitome Of Minimalism",
                source: "Mr.Phone",
                image: "https://i01.appmifile.com/webfile/globalimg/in/cms/97E65ECC-E105-9A20-6BD7-8A3235104C57.jpg",
            },
            {
                name: "MI SOUNDBAR",
                description: "We Looked Hard, But There Really Are no Faults.",
                source: "TechPP",
                image: "https://i01.appmifile.com/webfile/globalimg/in/cms/40F52E34-A946-E8B3-29F2-BBE4A5C7BEEE.jpg",
            },
        ],
    },
    offer: [
        {
            url: "https://in.event.mi.com/in/offer-with-mi",
            image: "https://i02.appmifile.com/31_operator_in/25/04/2021/37529e4f2964c9b26a671172950096ae.jpg?width=398&height=230",
        },
        {
            url: "https://in.event.mi.com/in/work-from-home-essentials",
            image: "https://i02.appmifile.com/884_operator_in/30/05/2021/1e91f02cd9aca02f7caf3c5ddadd2747.jpg?width=398&height=230",
        },
        {
            url: "https://xiaomi.giveindia.org/",
            image: "https://i02.appmifile.com/761_operator_in/27/04/2021/09489d6a77f96111372718a551d2799d.png?width=398&height=230",
        },
    ],
    starProduct: [
        {
            url: "https://www.mi.com/in/power-banks",
            image: "https://i02.appmifile.com/427_operator_in/09/05/2021/4cedd9d52d3d66e09ee27dde3914efe1.jpg?width=612&height=612",
        },
        {
            url: "https://store.mi.com/in/item/3203500001",
            image: "https://i02.appmifile.com/341_operator_in/30/05/2021/e866f96094c058af222f53bc97bcb5ed.jpg?width=612&height=612",
        },
        {
            url: "https://store.mi.com/in/item/3192900017",
            image: "https://i02.appmifile.com/402_operator_in/15/04/2021/d6d00b5cb2a212f4a9a13d4d7c1bdcc1.png?width=612&height=612",
        },
        {
            url: "https://www.mi.com/in/bands-fitness",
            image: "https://i02.appmifile.com/571_operator_in/22/10/2020/2df7eba98e739b3329dda041b05a0aac.jpg?width=612&height=612",
        },
    ],
    hotAccessories: {
        music: [
            {
                name: "Redmi Earbuds S",
                price: "₹ 1,799",
                image: "https://i01.appmifile.com/webfile/globalimg/in/cms/BF2A4279-A6D5-B4F0-FE37-633256CDC9FC.jpg",
            },
            {
                name: "Mi Soundbar",
                price: "₹ 4,999",
                image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1547107203.76021206.png",
            },
            {
                name: "Mi Neckband Bluetooth Earphones",
                price: "₹ 1,599",
                image: "https://i01.appmifile.com/webfile/globalimg/in/cms/A1C40BA8-574D-2FA0-62C0-3D7A2C964790.jpg",
            },
            {
                name: "Mi Super Bass Wireless Headphones",
                price: "₹ 1,799",
                image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1563264530.44121333.jpg?width=420&height=420",
            },
            {
                name: "Mi Dual Driver In-ear Earphones",
                price: "₹ 799",
                image: "https://i01.appmifile.com/webfile/globalimg/in/cms/E794F82C-8858-02F1-7C53-6FB0B4D0C4C6.jpg",
            },
        ],
        smartDevice: [
            {
                name: "Mi Smart Band 4",
                price: "₹ 2,099",
                image: "https://i01.appmifile.com/webfile/globalimg/in/cms/0E0F0769-6A69-5820-C8F0-F2B956C65BFA.jpg",
            },
            {
                name: "Mi Smart Water Purifier",
                price: "₹ 12,999",
                image: "https://i01.appmifile.com/webfile/globalimg/in/cms/BC643CF4-853C-24E4-1EEC-9D4FF614C86D.jpg",
            },
            {
                name: "Mi Watch Revolve",
                price: "₹ 9,999",
                image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1601293021.06313819.png",
            },
            {
                name: "Mi Smart Bedside Lamp 2",
                price: "₹ 2,499",
                image: "https://i01.appmifile.com/webfile/globalimg/in/cms/6A656178-B31B-39D1-AC43-9C7EC61C3D84.jpg",
            },
            {
                name: "Mi Smart LED Desk Lamp 1S",
                price: "₹ 2,499",
                image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1574669860.58966823.jpg?width=420&height=420",
            },
        ],
        home: [
            {
                name: "Mi Air Purifier 3",
                price: "₹ 10,999",
                image: "https://i01.appmifile.com/webfile/globalimg/in/cms/70A72569-C7EA-BBD7-591E-DC93EC3CDF34.jpg",
            },
            {
                name: "Mi Air Purifier 2C",
                price: "₹ 6,999",
                image: "https://i01.appmifile.com/webfile/globalimg/in/cms/7D8FAD13-1E44-9475-3555-949CBF3571AF.jpg",
            },
            {
                name: "Mi Router 4C",
                price: "₹ 999",
                image: "https://i01.appmifile.com/webfile/globalimg/in/cms/FD13B2EB-1AD5-67EE-FF6B-C3E2A0270556.jpg",
            },
            {
                name: "Mi Box 4K",
                price: "₹ 3,499",
                image: "https://i02.appmifile.com/919_updatepdf_in/15/05/2020/984e626e158fdeb7cc21aff04264773d.png",
            },
            {
                name: "Mi LED Wi-Fi Smart Bulb",
                price: "₹ 1,299",
                image: "https://i01.appmifile.com/webfile/globalimg/in/cms/441FC065-EEE7-5A64-9CF9-608EF2F82F60.jpg",
            },
        ],
        lifeStyle: [
            {
                name: "Mi Travel Backpack",
                price: "₹ 1,999",
                image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1536381648.16353261.png?width=420&height=420",
            },
            {
                name: "Mi Athleisure Shoes",
                price: "₹ 1,699",
                image: "https://i02.appmifile.com/363_operator_in/13/10/2020/c7bde508f128d7b1fd10a224d18a5333.png",
            },
            {
                name: "Mi Beard Trimmer",
                price: "₹ 1,399",
                image: "https://i01.appmifile.com/webfile/globalimg/in/cms/CEEE67A3-3578-7048-887D-CFC3D90B5D17.jpg",
            },
            {
                name: "Mi KN-95 Protective Mask (Pack of 5)",
                price: "₹ 399",
                image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1602500062.48215120.png?width=420&height=420",
            },
            {
                name: "Mi Portable Electric Air Compressor",
                price: "₹ 2,499",
                image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1592479075.0368979.png?width=420&height=420",
            },
            {
                name: "Mi T-shirts",
                price: "₹ 399 onwards",
                image: "https://i01.appmifile.com/webfile/globalimg/in/cms/0D320403-6180-D6D6-9F57-4EDF0FEB58C7.jpg",
            },
        ],
        mobileAccessories: [
            {
                name: "Cases & Covers",
                price: "₹ 49 onwards",
                image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1551164869.57618003.jpg",
            },
            {
                name: "Charger & USB Gadgets",
                price: "₹ 179 onwards",
                image: "https://i01.appmifile.com/webfile/globalimg/in/cms/5A5AA9AC-41A3-7E86-5922-928B312919B0.jpg",
            },
            {
                name: "Mi Wireless Power Bank 10000mAh",
                price: "₹ 2,499",
                image: "https://i01.appmifile.com/webfile/globalimg/in/cms/3CBAACCE-D18A-B241-A4F8-54A4CCE194A5.jpg",
            },
            {
                name: "10000mAh Mi Power Bank 3i",
                price: "₹ 999",
                image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1600434881.35114664.jpg?width=420&height=420",
            },
            {
                name: "Redmi SonicBass Wireless Earphones",
                price: "₹ 1,299",
                image: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1601900775.75794078.png?width=420&height=420",
            },
        ],
    },
    hotAccessoriesCover: {
        music: "https://i01.appmifile.com/webfile/globalimg/in/cms/500BFA0B-CBEF-5DFF-79A9-E925F9F2FEE9.jpg",
        smartDevice:
            "https://i02.appmifile.com/953_operator_in/17/06/2021/e12dde416676486fed36d0503d5bd65a.jpg",
        home: "https://i02.appmifile.com/663_operator_in/20/01/2021/0f6ac3c219428b6decbe7fb03d479060.jpg",
        lifeStyle:
            "https://i02.appmifile.com/677_operator_in/25/01/2021/8163c3c89feb2c83c73b019d5fd50181.jpg",
        mobileAccessories:
            "https://i01.appmifile.com/webfile/globalimg/in/cms/801ED76B-614B-5959-E2C3-1EC8E14C0ABD.jpg",
    },
    productReviews: [
        {
            image: "https://i02.appmifile.com/11_operator_in/19/05/2021/981f40e9e6ecc687153fc6a08b7c067d.jpg?width=606&height=252",
            review: "PRO DISPLAY. PRO CAMERAS",
            name: "REDMI NOTE 10 PRO",
            price: "₹ 15,999",
        },
        {
            image: "https://i02.appmifile.com/426_operator_in/10/05/2021/ced1802c9525a8939582544bb2822f90.jpg?width=606&height=252",
            review: "TRULY SMART. TRULY SAFE. TRULY CONVENIENT.",
            name: "MI SMART WATER PURIFIER ",
            price: "₹ 12,999",
        },
    ],
    videos: [
        {
            name: "Redmi Note 10 Pro Max",
            image: "https://i02.appmifile.com/769_operator_in/26/04/2021/2fab525c022f0d6c0dba8a6edcf12060.png?width=398&height=320",
        },
        {
            name: "Mi 10",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/2461CE83-F535-6B92-CBEE-5971984298E4.jpg?width=398&height=320",
        },
        {
            name: "Mi MIX Alpha",
            image: "https://i01.appmifile.com/webfile/globalimg/in/cms/FD2BD776-5489-44CA-F05A-C20C232A4848.jpg?width=398&height=320",
        },
    ],
    footer: {
        support: [
            {
                name: "Online Help",
                url: "https://www.mi.com/in/service/help/#category_id=1&pagenum=1&channel=1",
            },
            {
                name: "Customer Service",
                url: "https://www.mi.com/in/service/online/",
            },
            {
                name: "Shipping FAQ",
                url: "https://www.mi.com/in/service/shipping/",
            },
            {
                name: "Service Centres",
                url: "https://www.mi.com/in/service/repair/",
            },
            {
                name: "Warrenty",
                url: "https://www.mi.com/in/service/warranty/",
            },
            {
                name: "Mi Exchange",
                url: "https://www.mi.com/in/miexchange/",
            },
            {
                name: "Bulk Order",
                url: "https://www.mi.com/in/bulkbuy/",
            },
            {
                name: "User Guide",
                url: "https://www.mi.com/in/service/userguide/",
            },
            {
                name: "Laptop Drivers",
                url: "https://www.mi.com/in/service/support/laptop-drivers.html",
            },
            {
                name: "Mi Screen Protect",
                url: "https://www.mi.com/in/service/miphoneprotection/#miscreenprotect",
            },
            {
                name: "Mi Extended Warranty",
                url: "https://www.mi.com/in/service/miextendedwarranty/",
            },
        ],
        shopAndLearn: [
            {
                name: "Mi 10i",
                url: "https://www.mi.com/in/mi-10i/",
            },
            {
                name: "Mi 10T Series",
                url: "https://in.event.mi.com/in/mi-10t-series",
            },
            {
                name: "Mi 11 Ultra",
                url: "https://www.mi.com/in/mi-11-ultra/",
            },
            {
                name: "Mi 11X",
                url: "https://www.mi.com/in/mi-11x/",
            },
            {
                name: "Mi 11X Pro",
                url: "https://www.mi.com/in/mi-11x-pro/",
            },
            {
                name: "Redmi 8",
                url: "https://www.mi.com/in/redmi-8/",
            },
            {
                name: "Redmi 9",
                url: "https://www.mi.com/in/redmi-9/",
            },
            {
                name: "Redmi 9 Prime",
                url: "https://www.mi.com/in/redmi-9-prime/",
            },
            {
                name: "Redmi 9i",
                url: "https://www.mi.com/in/redmi-9i/",
            },
            {
                name: "Redmi 9A",
                url: "https://www.mi.com/in/redmi-9a/",
            },
            {
                name: "Redmi Note 10",
                url: "https://www.mi.com/in/redmi-note-10/",
            },
            {
                name: "Redmi Note 10 Pro",
                url: "https://www.mi.com/in/redmi-note-10-pro/",
            },
            {
                name: "Redmi Note 10 Pro Max",
                url: "https://www.mi.com/in/redmi-note-10-pro-max/",
            },
            {
                name: "Redmi Note 9 Pro",
                url: "https://www.mi.com/in/redmi-note-9-pro/",
            },
            {
                name: "Redmi Note 9",
                url: "https://www.mi.com/in/redmi-note-9/",
            },
            {
                name: "Redmi Note 9 Pro Max",
                url: "https://www.mi.com/in/redmi-note-9-pro-max/",
            },
            {
                name: "TVs",
                url: "https://www.mi.com/in/all-mi-tv",
            },
            {
                name: "Laptops",
                url: "https://www.mi.com/in/xiaomi-laptops",
            },
        ],
        retailStore: [
            {
                name: "Mi Home",
                url: "https://www.mi.com/in/service/mihome/",
            },
            {
                name: "Mi Authorised Stores",
                url: "https://www.mi.com/in/service/authorized_stores/",
            },
        ],
        aboutUS: [
            {
                name: "Xioami",
                url: "https://www.mi.com/in/about/",
            },
            {
                name: "Mediakit",
                url: "https://www.mi.com/in/mediakit/",
            },
            {
                name: "Culture",
                url: "https://www.mi.com/in/about/#culture",
            },
            {
                name: "User Agreement",
                url: "https://www.mi.com/in/about/agreement/",
            },
            {
                name: "Privacy Policy",
                url: "https://www.mi.com/in/about/privacy/",
            },
            {
                name: "Declarations",
                url: "https://www.mi.com/in/service/support/mideclare.html",
            },
            {
                name: "Integrity & Compliance",
                url: "https://integrity.mi.com/global",
            },
            {
                name: "Smartphone Quality",
                url: "https://www.mi.com/in/smartphone-quality/",
            },
            {
                name: "TV Quality",
                url: "https://www.mi.com/in/tv-quality/",
            },
            {
                name: "Service Quality",
                url: "https://www.mi.com/in/service-quality/",
            },
            {
                name: "Environment",
                url: "https://www.mi.com/in/service/support/ewastetakeback.html",
            },
            {
                name: "Sitemap",
                url: "https://www.mi.com/in/sitemap",
            },
        ],
        contactUs: [
            {
                name: "Email",
                url: "https://in.event.mi.com/in/questionnaire/email_us",
            },
            {
                name: "Careers",
                url: "https://www.mi.com/in/about/#career",
            },
        ],
    },
};
